(() => {
  if (customElements.get('ezy-promo-carousel')) return;
  customElements.define('ezy-promo-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-go]')];
      this.toggle = this.querySelector('[data-toggle]');
      this.status = this.querySelector('[data-status]');
      if (!this.toggle || this.slides.length < 2) return;
      this.index = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.hovered = false;
      this.inView = true;
      this.events = new AbortController();
      const on = (target, name, fn) => target.addEventListener(name, fn, {signal:this.events.signal});
      on(this, 'pointerdown', event => {
        if(event.target.closest('[data-toggle]')) this.toggleWasPaused = this.paused;
      });
      on(this, 'click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-toggle')) { this.paused = !(this.toggleWasPaused ?? this.paused); this.toggleWasPaused = undefined; this.schedule(); }
        if (button.hasAttribute('data-prev')) this.show(this.index - 1, true);
        if (button.hasAttribute('data-next')) this.show(this.index + 1, true);
        if (button.hasAttribute('data-go')) this.show(Number(button.dataset.go), true);
      });
      on(this, 'focusin', () => { this.paused = true; this.schedule(); });
      on(this, 'keydown', event => {
        if (!event.target.closest('.ezy-promo__controls')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.reduced, 'change', () => { if(this.reduced.matches) this.paused=true; this.schedule(); });
      this.observer = new IntersectionObserver(entries => {
        this.inView=entries[0].isIntersecting; this.schedule();
      }, {threshold:.15});
      this.observer.observe(this);
      this.show(0);
    }
    show(next, announce = false) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active;
      });
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      if(announce) this.status.textContent = this.slides[this.index].getAttribute('aria-label');
      this.dataset.active = String(this.index);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.toggle.querySelector('path').setAttribute('d', this.paused ? 'm9 5 10 7-10 7Z' : 'M9 5v14M15 5v14');
      this.dataset.paused = String(this.paused);
      if(!this.paused && this.inView && !document.hidden) this.timer=setTimeout(()=>this.show(this.index+1),6000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.events?.abort(); this.observer?.disconnect(); this.ready=false; }
  });
})();
